export enum MealUpdateStatus {
  //   ASSIGNED = 'Assigned',
  //   ACQUIRED = 'Acquired',
  COLLECTING = 'Collecting',
  DELIVERING = 'Delivering',
  AT_DESTINATION = 'AtDestination',
  COMPLETED = 'Completed',
  CANCELED = 'Canceled',
  NOT_DELIVERED = 'NotDelivered'
}
